import { VideoPlayerContainer } from './VideoPlayerContainer'

export const VideoPlayer = VideoPlayerContainer
